// hooks/useLabCurrency.js
// Shared helper for statement / invoice screens.
// Returns the lab's CURRENT currency (from CurrencyContext, re-read from the
// backend when the screen opens) so no screen needs a hardcoded symbol.
// Currency is never stored on statements/invoices, so old and new documents
// always render in whatever currency is currently selected in Settings.
import { useEffect } from "react";
import { useCurrency } from "../context/currencyContext";

export const useLabCurrency = ({ refreshOnMount = true } = {}) => {
  const { currency, refreshCurrency, loading } = useCurrency();

  useEffect(() => {
    if (refreshOnMount && refreshCurrency) refreshCurrency();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const currencySymbol = currency?.currencySymbol ?? "";
  const currencyCode = currency?.currencyCode ?? "";

  return { currency, currencySymbol, currencyCode, currencyLoading: loading };
};

export default useLabCurrency;
